export default "__VITE_ASSET__C2I3Zt7P__"